import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import { Route } from 'react-router-dom'
import BusinessOffers from './Offers'
import BusinessDashboard from './Dashboard'
import CreateOffer from '../Offers/CreateOffer'
import AdminOfferReview from '../Offers/AdminOfferReview'

const Business = ({ match }) => (
  <Fragment>
    <Route exact path={`${match.url}`} component={BusinessDashboard} />
    <Route exact path={`${match.url}/offers`} component={BusinessOffers} />
    <Route exact path={`${match.url}/offers/new`} component={CreateOffer} />
    <Route path={`${match.url}/offers/review/:offerId`} component={AdminOfferReview} />
  </Fragment>
)

Business.propTypes = {
  match: PropTypes.shape({
    url: PropTypes.string.isRequired
  }).isRequired
}

export default Business
